export enum CreateBookingNoAdvanceFeeEndpoint {
    CREATE = '/v1/booking/create-booking-no-advance-fee',
}
